import mutations from './mutations';
import getters from './getters';
import actions from './actions';

export default {
    namespaced: true,
    state: {
        items: [],
        selectedThemaId: undefined,
        sortBy: {
            key: 'Änderungsdatum',
            order: 'asc'
        },
        konzessionsabgaben: [],
        konzessionsabgabenFilterValues: {
            communes: [],
            documentTypes: [],
            years: []
        },
        konzessionsabgabenPagination: {
            page: 1,
            pageSize: 25,
            hasMore: false
        },
        konzessionsabgabenLoading: false
    },
    mutations,
    getters,
    actions,

}
